import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { DropDownCalenderPortal } from '../../dropdowns/portal/DropDownCalenderPortal';
import { getErrorValidateWithId, handleResetFieldTreeWorks } from '../../../utilities/works';
import CellContent from './CellContent';
import FieldTreeService from '../../../services/FieldTrees';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import Loader from '../../Loader';
import { getWorkTime } from './WorkEarlyTimesTemplate';
import { formatDecimal } from './WorkDayWorkerTemplate';

const fieldId = SessionStorageService.getFieldId();

const WorkDateTemplate = ({
  grid,
  context,
  msgValidate,
  handlePushParam,
  fieldInfo,
  column,
  tabKeyStatus,
}) => {
  const {
    isAbortedOrApproved,
    field_tree_id,
    work_date: prevWorkDate,
    job_id,
    foreman_user_id,
    display_fifteen_minute_flg,
    work_dayworkers,
    work_group: { work_hour_zone },
  } = context.item;

  const handleSetData = async date => {
    Loader.start();
    const isExistPartnerCompany = await getPartnerCompanyById(date);
    const isExistJob = await getWorkJobById(date);
    const isExistForeman = await getForemanUserById(date);
    const v = grid.collectionView;
    v.currentItem['work_date'] = date;
    if (!isExistPartnerCompany) {
      v.currentItem['company_name'] = '';
      v.currentItem['field_tree_id'] = null;
      v.currentItem['is_data_changed']['field_tree_id'] = true;
    }
    if (!isExistJob) {
      v.currentItem['job_id'] = null;
      v.currentItem['job_name'] = '';
      v.currentItem['is_data_changed']['job_id'] = true;
    }
    if (!isExistForeman) {
      v.currentItem['foreman_user_id'] = null;
      v.currentItem['foreman_user_name'] = '';
      v.currentItem['is_data_changed']['foreman_user_id'] = true;
    }
    v.currentItem['manager_user_id'] = null;
    v.currentItem['manager_user_name'] = '';
    if (!v.currentItem['is_data_changed']['manager_user_id']) {
      v.currentItem['is_data_changed']['manager_user_id'] = true;
    }
    v.editItem(v.currentItem);
    if (!v.currentItem['is_data_changed']['work_date']) {
      v.currentItem['is_data_changed']['work_date'] = true;
    }
    const prevWorkTime = getWorkTime(prevWorkDate, fieldInfo);
    const workTime = getWorkTime(date, fieldInfo);
    const prevWoringTime = prevWorkTime[work_hour_zone].working_time;
    let workingTime = workTime[work_hour_zone].working_time;

    if (display_fifteen_minute_flg && prevWoringTime !== workingTime) {
      workingTime = moment.duration(workingTime).asHours();
      let sumDayWorker = 0;
      _.each(work_dayworkers, workDayworker => {
        if (Number(workDayworker.working_temp_hour) > workingTime) {
          workDayworker.working_temp_hour = workingTime;
        }
        let cur = workDayworker.working_temp_hour / workingTime;
        let rlt = workDayworker.working_temp_person * cur;
        workDayworker.dayworker = rlt.toFixed(2);
        sumDayWorker += _.toNumber(workDayworker.dayworker);
      });

      v.currentItem['work_dayworkers'] = work_dayworkers;
      v.currentItem['calcd_sum_man_hours'] = formatDecimal(sumDayWorker);
      v.currentItem['is_data_changed']['work_dayworkers'] = true;
    }

    v.commitEdit();
    handlePushParam(context.item, 'work_date');
    Loader.done();
  };

  const getWorkJobById = async date => {
    if (!field_tree_id || !fieldId) {
      return false;
    }
    const params = {
      is_limit: 1,
      offset: 0,
      limit: 1,
      field_tree_id,
      date_to: date,
      field_id: fieldId,
      job_id,
    };
    try {
      const response = await FieldTreeService.treeJobs(
        fieldId,
        field_tree_id,
        params,
        false,
      );
      if (!response.result) {
        return false;
      }
      return !_.isEmpty(_.get(response, 'data.entities.jobs', []));
    } catch (error) {
      handleResetFieldTreeWorks(grid, handlePushParam, context, error);
      return false;
    }
  };

  const getPartnerCompanyById = async date => {
    if (!fieldId) {
      return false;
    }
    const params = {
      is_limit: 1,
      offset: 0,
      limit: 1,
      date_to: date,
      work_hour_zone,
      field_id: fieldId,
      field_tree_id,
    };
    const response = await FieldTreeService.selectableCompaniesList(
      fieldId,
      params
    );
    if (!response.result) {
      return false;
    }
    return !_.isEmpty(_.get(response, 'data.entities.companies', []));
  };

  const getForemanUserById = async date => {
    if (!field_tree_id) {
      return null;
    }
    const params = {
      is_limit: 1,
      offset: 0,
      limit: 1,
      field_id: fieldId,
      job_id,
      date_to: date,
      user_id: foreman_user_id,
    };
    try {
      const response = await FieldTreeService.treeUsers(
        fieldId,
        field_tree_id,
        params,
        false
      );
      if (!response.result) {
        return false;
      }
      return !_.isEmpty(_.get(response, 'data.entities', []));
    } catch (error) {
      handleResetFieldTreeWorks(grid, handlePushParam, context, error);
      return false;
    }
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, 'work_date');
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(context, 'item.is_data_changed.work_date')}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <DropDownCalenderPortal
        onChange={handleSetData}
        value={context.item.work_date}
        key={context.item.id}
        disabled={isAbortedOrApproved}
        tabKeyStatus={tabKeyStatus}
      />
    </CellContent>
  );
};

export default WorkDateTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/WorkDateTemplate.jsx